module.exports = __webpack_public_path__ + "static/img/5.325e02b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/5.png
// module id = a+2Q
// module chunks = 0